import React from 'react';

type userIconProps = {
    user: string;
    iHeight: string;
    iWidth: string;
    iFontSize: string;
};

export const UserInitialIcon = ({ user, iHeight, iWidth, iFontSize }: userIconProps) => {
    const splitUser = user?.split(' ');
    let firstInitial = '';
    if (splitUser && splitUser.length > 0) {
        firstInitial = splitUser[0].charAt(0).replace(',', '');
        firstInitial += splitUser.length > 1 ? splitUser[1].charAt(0).replace(',', '') : '';
    }

    return (
        <div
            style={{
                backgroundColor: '#A9A5FF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 30,
                width: iHeight,
                height: iWidth,
            }}
        >
            <span
                style={{
                    color: 'white',
                    fontSize: iFontSize,
                }}
            >
                {firstInitial}
            </span>
        </div>
    );
};
